import { render, staticRenderFns } from "./IntroPopup.vue?vue&type=template&id=66d38888&"
import script from "./IntroPopup.vue?vue&type=script&lang=js&"
export * from "./IntroPopup.vue?vue&type=script&lang=js&"
import style0 from "./IntroPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports